<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <FrotixManagementList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import FrotixManagementList from '@/components/frotix-management/Index'

  export default {
    name: 'FrotixManagementIndex',
    components: {
      PageTitle,
      PageRowWrapper,
      FrotixManagementList
    }
  }
</script>
